import React from 'react';
import PropTypes from 'prop-types';
import { ThermoboxForm } from '../thermobox-form';
import { SimpleTableComponent } from '../../../../components/simple-table';
import { THERMOBOX_TABLE_COLUMNS_NAMES } from '../../constants';

export const ThermoboxModalContent = ({ isLoading, thermoboxInfo, isThermoboxFormOpen }) => {
	if (isThermoboxFormOpen) {
		return <ThermoboxForm isLoading={isLoading} />;
	}

	return (
		<SimpleTableComponent
			rows={thermoboxInfo}
			isTableDataLoading={isLoading}
			columns={THERMOBOX_TABLE_COLUMNS_NAMES}
			withOutMinHeight
		/>
	);
};

ThermoboxModalContent.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	thermoboxInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.shape({
					name: PropTypes.string,
					role: PropTypes.string,
				}),
				PropTypes.shape({
					length: PropTypes.string,
					width: PropTypes.string,
					height: PropTypes.string,
				}),
			]).isRequired,
		}),
	),
	isThermoboxFormOpen: PropTypes.bool.isRequired,
};
